/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Box, TextField, Typography, FormGroup, FormControl, Chip } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Autocomplete from '@mui/material/Autocomplete';
import { ThemeProvider } from "@mui/material/styles";
import en from "../../nls/en.json";
import { theme, OptionsWrapper, ChipWrapper } from "../Styles/AcademicSubjectsStyle";
import { useSelector, useDispatch } from "react-redux";
import { useMemo } from "react";
import { isEmpty, checkDuplicateChipValue } from "../../utils/constants";
import { getSchooList } from "../../store/studentSlice";
import { getUniversityList } from "../../store/userSlice";
import { useLocation } from "react-router-dom";

const MentorSchool = ({getSchool, isFromAcademicSchoolEdit}) => {
    const location = useLocation();
    const mentorId = location?.state?.mentorId;
    const dispatch = useDispatch();
    const { schoolList, savedAnswer, studentProfileIfo } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
    const { universityList } = useSelector(({ userSliceHome }) => userSliceHome);
    const { MENTOR_BACKGROUND } = mentorId ? studentProfileIfo : savedAnswer;
    const defaultvals = !isEmpty(MENTOR_BACKGROUND) && MENTOR_BACKGROUND?.find(obj => obj?.sub_category_name === 'SCHOOLS_YOU_ARE_INTERESTED')?.master_data || [];
    const [selectedChips, setSelectedChips] = useState(defaultvals);
    const [searchQueryUniversity, setSearchQueryUniversity] = useState('');
    const [searchQuerySchool, setSearchQuerySchool] = useState('');

    const handleChipSelection = (val) => {
        setSelectedChips(val);
    }
    const handleSchoolInputChange = (event, newInputValue) => {
        setSearchQuerySchool(newInputValue);
        setTimeout(() => {
            dispatch(getUniversityList(1, "", newInputValue));
          }, 200);
        // handleDebouncedChange(newInputValue);
    };
    const handleDeleteChip = (chipToDelete) => {
        setSelectedChips((chips) => chips?.filter((chip) => chip?.id !== chipToDelete?.id));
    };
    const loadMoreResults = () => {
        if (universityList?.pagination?.isNextPage) {
            dispatch(getUniversityList(universityList?.pagination?.nextPage, "", searchQuerySchool));
        }
    }

    useMemo(()=>{getSchool(selectedChips) },[selectedChips]);

    return (
        <ThemeProvider theme={theme}>
            <Box>
                <Box variant="form">
                    {!isFromAcademicSchoolEdit && <Typography variant="h2">{en.ADDMISION_RESULT} </Typography>}
                    <OptionsWrapper>
                        <Typography variant="h3" sx={{ mb: 0 }}> {en.ADMITTED_TITLE}</Typography>
                        <FormGroup sx={{ mt: 2 }}>
                            <FormControl variant="filled">
                                <Typography variant="h3" sx={{ mb: 2, mt: 0 }}>
                                    {/* {data && data[1]?.question_text} */}
                                </Typography>
                                <Autocomplete
                                    multiple
                                    id="searchSchool"
                                    options={universityList?.result || []}
                                    getOptionLabel={(option) => option?.name}
                                    onChange={(event, value) =>  checkDuplicateChipValue(value, selectedChips, setSelectedChips)}
                                    value={selectedChips}
                                    inputValue={searchQuerySchool}
                                    onInputChange={handleSchoolInputChange}
                                    ListboxProps={{
                                        onScroll: (event) => {
                                            const listboxNode = event.currentTarget;
                                            if (Math.ceil(listboxNode.scrollTop) + listboxNode.clientHeight === listboxNode.scrollHeight) {
                                                loadMoreResults()
                                            }
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Search"
                                            variant="outlined"
                                            sx={{ marginBottom: "16px !important" }}
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchOutlinedIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                                <ChipWrapper>
                                    {selectedChips?.map((chip) => (
                                        <Chip
                                            key={chip?.id}
                                            label={chip?.name}
                                            onDelete={() => handleDeleteChip(chip)}
                                            deleteIcon={<CloseOutlinedIcon />}
                                        />
                                    ))}
                                </ChipWrapper>
                            </FormControl>
                        </FormGroup>
                    </OptionsWrapper>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default MentorSchool;
